import { render } from "./SendersComponent.vue?vue&type=template&id=08bd7664&scoped=true"
import script from "./SendersComponent.vue?vue&type=script&lang=js"
export * from "./SendersComponent.vue?vue&type=script&lang=js"

import "./SendersComponent.vue?vue&type=style&index=0&id=08bd7664&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08bd7664"]])

export default __exports__